import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="layout-footer">
      Sokil CRM &copy; {{ currentYear }}
    </div>
  `
})
export class AppFooter {
  currentYear = new Date().getFullYear();
}
